import { render, staticRenderFns } from "./IsCompletedCell.vue?vue&type=template&id=b9e35f52"
import script from "./IsCompletedCell.vue?vue&type=script&lang=js"
export * from "./IsCompletedCell.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports